import React, { useEffect, useRef } from "react";
import styles from "./styles/Moves.module.css";
import { goToPosition, useGamePlay } from "../../ducks/gamePlay";
import MoveButtons from "./MoveButtons";
import GameResult from "./GameResult";
// import TestGameResult from "./TestGameResult";

export default function Moves() {
  const {
    moves,
    positionIndex,
    gameEnded,
    result,
    status,
    playingWhite,
    opponent,
  } = useGamePlay();

  const gameResultProps = {
    result,
    status,
    playingWhite,
    opponentName: opponent.displayName,
  };

  const movesDiv = useRef(null);

  useEffect(() => {
    movesDiv.current.scrollTop = movesDiv.current.scrollHeight;
  }, []);

  useEffect(() => {
    if (positionIndex === moves.length || moves.length === 0) {
      movesDiv.current.scrollTop = movesDiv.current.scrollHeight;
    } else {
      movesDiv.current.scrollTop = Math.floor(positionIndex / 2 - 0.1) * 30;
    }
  }, [positionIndex]);

  useEffect(() => {
    if (gameEnded) {
      movesDiv.current.scrollTop = movesDiv.current.scrollHeight;
    }
  }, [gameEnded]);

  function renderMoves(moves, positionIndex, goToPosition) {
    const rows = [];
    let index = 1;

    for (let i = 0; i < moves.length; i = i + 2) {
      const whiteMove = moves[i];
      const blackMove = moves[i + 1];
      const whiteStyle =
        i === positionIndex - 1 ? styles.currentMove : undefined;
      const blackStyle =
        i === positionIndex - 2 ? styles.currentMove : undefined;

      const whiteCol = (
        <td onClick={() => goToPosition(i + 1)} className={whiteStyle}>
          {whiteMove.from + whiteMove.to}
        </td>
      );

      const blackCol = blackMove ? (
        <td onClick={() => goToPosition(i + 2)} className={blackStyle}>
          {blackMove.from + blackMove.to}
        </td>
      ) : (
        <td></td>
      );

      const keyId = `${i}${whiteMove}${blackMove}`;
      rows.push(
        <tr key={keyId}>
          <td>{index}</td>
          {whiteCol}
          {blackCol}
        </tr>
      );
      index++;
    }
    return rows;
  }

  function renderGameResult() {
    return (
      <tfoot>
        <tr>
          <td colSpan={3}>
            <div className="flex flex-col items-center pt-5">
              <GameResult {...gameResultProps} />
            </div>
          </td>
        </tr>
      </tfoot>
    );
  }

  return (
    <div className={`${styles.moves} bg-gray-50`}>
      <div className={`${styles.body} bg-gray-50`} ref={movesDiv}>
        <table width="100%">
          <tbody>{renderMoves(moves, positionIndex, goToPosition)}</tbody>
          {gameEnded && renderGameResult()}
        </table>
      </div>
      <MoveButtons />
    </div>
  );
}
